export default {
    navigationBarTitleText: "选择联系人",
  };
  